import { axiosInstance } from "./config";

export default {
  state: {
    expense: {},
  },
  mutations: {
    Set_expense(state, payload) {
      state.expense = payload;
    },
    Set_update_expense(state, payload) {
      let expense = state.expense.find((g) => g.id == payload.id);
      expense.title_en = payload.title_en;
      expense.title_it = payload.title_it;
      expense.title_ru = payload.title_ru;
      expense.subtitle_en = payload.subtitle_en;
      expense.subtitle_it = payload.subtitle_it;
      expense.subtitle_ru = payload.subtitle_ru;
      expense.highlighted = payload.highlighted ? 1 : 0;
    },
  },
  actions: {
    async Get_expense({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/expense${payload}`)
        .then(function (data) {
          commit("Set_expense", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_expense(commit, payload) {
      return await axiosInstance
        .post("/expense/", payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_expense({ commit }, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/expense/" + payload.id, formData, config)
        .then(function (data) {
          commit("Set_update_expense", data?.data?.data);
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_expense(commit, payload) {
      return await axiosInstance
        .put("/expense/" + payload.id)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_expense: (state) => state.expense,
  },
};
